<div class="flex flex-column align-items-center justify-content-center">
  <p-chart
    class="totalFuelConsumption-diagram"
    type="doughnut"
    [data]="totalFuelConsumptionChartData"
    [options]="totalFuelConsumptionChartOptions"
    [plugins]="totalFuelConsumptionChartPlugins"
    style="height: 176px; max-width: 100%; padding-top: 8px"></p-chart>
</div>
<div class="flex justify-content-center gap-4 text-sm">
  <div *ngIf="totalFuelConsumptionChartData.datasets[0].data[0] !== 0" class="flex align-items-center gap-1">
    <span class="border-round-sm h-1rem inline-block w-1rem blue"></span>Main Engines
  </div>
  <div *ngIf="totalFuelConsumptionChartData.datasets[0].data[1] !== 0" class="flex align-items-center gap-1">
    <span class="border-round-sm h-1rem inline-block w-1rem gray"></span>Aux Engines
  </div>
  <div *ngIf="totalFuelConsumptionChartData.datasets[0].data[2] !== 0" class="flex align-items-center gap-1">
    <span class="border-round-sm h-1rem inline-block w-1rem green"></span>Boilers
  </div>
</div>
